import React from "react";
import ServicePage from "../components/ServicePage";
function ManagedITSupportPage() {
	const title = "Privacy Statement";

	const content = {
		title: "Privacy Statement ",
		paragraphs: [],
		mainOffer: {
			title: "SMS Terms & Conditions",
			description:
				"",
			bulletPoints: [
				`Effective Date: [Insert Date]`,

				`1. Overview`,
				`RightClick Professional Services ("RPS," "we," "us," or "our") may send SMS (text) messages to clients and contacts who have engaged with our support team. By communicating with us via text message, you agree to these Terms & Conditions.`,

				`2. Types of Messages You May Receive`,
				`RPS uses SMS solely for client service and support purposes. Messages may include:`,
				`- Replies to support tickets or service requests`,
				`- Clarifications or updates related to an open ticket`,
				`- Scheduling or coordination related to technical support`,
				`RPS does not use SMS for marketing, promotional, or informational campaigns.`,

				`3. Message Frequency`,
				`RPS only sends SMS messages in direct response to your inquiries or active support tickets. We do not proactively initiate text conversations or send automated notifications.`,

				`4. Message and Data Rates`,
				`Message and data rates may apply according to your mobile carrier�s plan. RPS is not responsible for any fees charged by your carrier.`,

				`5. Privacy`,
				`Your privacy is important to us. Please review our Privacy Policy (https://www.rightclickproserve.com/privacy) for details on how we collect, use, and protect your information.`,

				`6. Opt-In`,
				`By texting RPS or providing your number during a support interaction, you consent to receive SMS responses related to that specific inquiry or ticket. Consent is not required to purchase or receive services.`,

				`7. Opt-Out`,
				`You may opt out at any time by replying STOP to any RPS text message. After opting out, you will receive one final confirmation message. You may also contact us at support@rightclickproserve.com to be removed.`,

				`8. Help`,
				`For assistance, reply HELP to any RPS message or email support@rightclickproserve.com.`,

				`9. Supported Carriers`,
				`SMS delivery is supported by major U.S. carriers including AT&T, Verizon, T-Mobile, and others. Delivery may not be available on all networks.`,

				`10. Changes to These Terms`,
				`We may update these Terms & Conditions from time to time. The latest version will always be available at this URL.`,

			],
			illustration: "/images/illustrations/consulting-illustration.png",
		},
	};

	const services = null;

	return <ServicePage title={title} content={content} services={services} />;
}

export default ManagedITSupportPage;
